module.exports = __webpack_public_path__ + "assets/img/header2.68522270.png";